import { Button, Dialog, Input, P, Space } from '@dnb/eufemia';
import { trash as TrashIcon } from '@dnb/eufemia/icons';
import { useState } from 'react';

interface DeleteDialogProps {
  id: string;
  title: string;
  variant: 'tertiary' | 'secondary';
  onDelete: (id: string) => void;
}

export default function DeleteDialog({ id, title, variant, onDelete }: DeleteDialogProps) {
  const [open, setOpen] = useState(false);
  const [passphrase, setPassphrase] = useState('');

  return (
    <Dialog
      confirmType="warning"
      icon={TrashIcon}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      right="small"
      title="Are you sure you want to delete this content?"
      triggerAttributes={{
        text: 'Delete page',
        icon: TrashIcon,
        variant: variant,
      }}
      variant="confirmation"
    >
      <div>
        <P>This will also delete every children from this content, and this action cannot be undone.</P>

        <P>
          Please enter <b>{title}</b> in the field below
        </P>

        <Space top="medium">
          <Input
            onChange={({ value }) => setPassphrase(value)}
            onPaste={(e) => e.preventDefault()}
            placeholder="Enter passphrase"
            stretch
          />
        </Space>
      </div>
      <Dialog.Action>
        <Button iconPosition="left" onClick={() => setOpen(false)} text="Cancel" variant="secondary" />
        <Button
          disabled={passphrase !== title}
          onClick={() => {
            onDelete(id);
            setOpen(false);
          }}
          text="Delete"
        />
      </Dialog.Action>
    </Dialog>
  );
}
